import { HOST } from "../constants/HostConstants";

export const allKeyTransactions = async ({ setTransactions }) => {
  try {
    const response = await fetch(`${HOST}/api/transaction/adminKeyHistoryAll`, {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch transactions: ${response.status}`);
    }

    const data = await response.json();
    if (Array.isArray(data)) {
      setTransactions(data);
    } else {
      setTransactions([]);
    }
    return data;
  } catch (error) {
    console.error("Error fetching key transactions:", error);
    setTransactions([]);
    throw error;
  }
};
